<template>
  <div>
    <v-card class="transparent" flat>
      <v-card-title
        v-if="!helpers.dataIsLoading"
        class="px-0"
        :class="
          $vuetify.breakpoint.smAndDown ? 'subtitle-1 font-weight-medium' : ''
        "
        >Meine letzten Stundenmeldungen<v-spacer></v-spacer>
        <v-btn
          text
          outlined
          small
          :to="{
            name: 'accounting-time-sheets',
          }"
          >Alle anzeigen</v-btn
        >
      </v-card-title>
      <div>
        <v-skeleton-loader
          v-if="helpers.dataIsLoading"
          elevation="2"
          type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
        ></v-skeleton-loader>
        <v-data-iterator
          v-else
          :items="timeSheets"
          no-data-text="Keine Stundenmeldungen vorhanden"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-card>
              <v-row no-gutters>
                <v-col
                  v-for="(timeSheet, index) in props.items"
                  :key="index"
                  cols="12"
                >
                  <v-list-item
                    :to="{
                      name: 'accounting-time-sheets-details',
                      params: { itemId: timeSheet.meta.id },
                    }"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{
                        timeSheet.title
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <p style="line-height: 1.6" class="mb-0">
                          <v-icon small left>mdi-account-credit-card</v-icon
                          >{{
                            timeSheet.payrollType?.title
                              ? timeSheet.payrollType.title
                              : "Fehlende Abrechnungsart"
                          }}
                          <br />
                          <v-icon small left>mdi-clock-edit</v-icon
                          ><span>
                            Erstellt am
                            {{
                              timestampConverter(timeSheet.meta.createdAt)
                            }}</span
                          >
                        </p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <time-sheet-status-chip :status="timeSheet.status" small>
                      </time-sheet-status-chip>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="props.items.length != index + 1"></v-divider>
                </v-col>
              </v-row>
            </v-card>
          </template>
        </v-data-iterator>
      </div>
    </v-card>
  </div>
</template>

<script>
import { ACCOUNTING } from "@/store/modules.js";
import { GET_TIME_SHEETS } from "@/store/action-types.js";
import TimeSheetStatusChip from "@/components/accounting/time-sheets/TimeSheetStatusChip.vue";
export default {
  name: "self-service-open-duty-expenses",
  props: {},
  components: {
    TimeSheetStatusChip,
  },
  data() {
    return {
      helpers: {
        dataIsLoading: false,
      },
    };
  },
  computed: {
    timeSheets() {
      return this.$store.state.accounting.timeSheets;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${ACCOUNTING}${GET_TIME_SHEETS}`, {
        organizationId: this.$route.params.organizationId,
        query: {
          queryIsFiltered: true,
          noDutyReports: true,
          onlyOwn: true,
          orderQuery: true,
        },
        paginationLimit: 3,
      });
    },
    timestampConverter(timestamp) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
